
import Grid from "@mui/material/Grid";
import { format , subDays } from 'date-fns';
import { useLocation } from "react-router-dom";
import GradientLineChart from "examples/Charts/LineCharts/GradientLineChart";
import GradientLineChartData3 from "./GradientLineChartData3";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import { Box, CircularProgress } from "@mui/material";



function Default3() {
    const [gradientLineChartData, setGradientLineChartData] = useState(null)
    const location = useLocation();
    const params = new URLSearchParams(location.search)
    const start_date = params.get("start_date")
    const end_date = params.get("end_date")
    const dateRange = {start_date , end_date}
    const start = dateRange.start_date || format(subDays(new Date(), 29), "yyyy-MM-dd")
    const end= dateRange.end_date || format(new Date(), "yyyy-MM-dd");
    const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    GradientLineChartData3(start, end)
      .then((data) => setGradientLineChartData(data))
      .finally(() => setLoading(false));
  }, [start, end]);

    return (
    <Grid item xs={12} lg={12}>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
          <CircularProgress color="green" />
        </Box>
      ) : (
        gradientLineChartData && (
          <SoftBox>
            <GradientLineChart
              title="New Visitors"
              chart={gradientLineChartData}
              dateRange={{ start_date, end_date }}
            />
          </SoftBox>
        )
      )}
    </Grid>
  );

}
export default Default3;

































